// Verloop van een taak (tabblad Verloop in de taaklade): statusupdates en wat er met de taak gebeurde, van oud naar
// nieuw. De server stelt het samen uit de updates, het logboek van de app, de momentopnames en Planner. De gelogde
// uren staan in het tabblad Uren (TaskHours).
import { useQuery } from "@tanstack/react-query";
import { call } from "./api";

export interface HistoryEvent {
  id: string;
  /**
   * update: een statusupdate; app: een wijziging via de app; planner: in Planner zelf (uit de momentopnames, zonder
   * naam), de aanmaak of het Teams-gesprek; mark: vanaf hier houdt de app het bij
   */
  kind: "update" | "app" | "planner" | "mark";
  /** tijdstip (ISO); null voor wat de hele dag geldt */
  at: string | null;
  day: string;
  /** bij een update de tekst; anders de zin zonder de naam ervoor */
  text: string;
  icon: string;
  who: string | null;
  personId: string | null;
  src: string;
  /** update: het statuslabel, en het label ervoor als de update het veranderde */
  label?: string | null;
  labelFrom?: string | null;
}

export interface Verloop {
  events: HistoryEvent[];
  trackedSince: string;
  latest: HistoryEvent | null;
}

export const historyApi = {
  get: (taskId: string) => call<Verloop>("GET", `/api/tasks/${taskId}/verloop`),
  post: (taskId: string, body: { text: string; label: string; labelFrom: string | null; changeId: number | null }) =>
    call<{ ok: boolean; event: HistoryEvent }>("POST", `/api/tasks/${taskId}/updates`, body),
};

/** Het verloop van één taak; ververst elke minuut zolang de lade openstaat. */
export function useVerloop(taskId: string) {
  return useQuery({ queryKey: ["verloop", taskId], queryFn: () => historyApi.get(taskId), refetchInterval: 60e3, staleTime: 15e3 });
}

/** De laatste statusupdate per taak, voor de lijst in Taken ("update 14/10 · Lennert"). */
export interface LatestUpdate { at: string; who: string; personId: string; label: string }
export function useLatestUpdates(enabled = true) {
  return useQuery({
    queryKey: ["updates-latest"], enabled, refetchInterval: 60e3, staleTime: 30e3,
    queryFn: () => call<{ byTask: Record<string, LatestUpdate> }>("GET", "/api/updates/latest").then((r) => r.byTask),
  });
}
